module.exports = __webpack_public_path__ + "static/5_equality-912c09095c2a96eb9031a54fe4cc163e.png";